var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconHomeChecked(props) {
    var id = Math.random().toString(16).substr(2);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("g", { fillRule: "evenodd", clipPath: "url(#icon-home-clip-path-" + id + ")", clipRule: "evenodd", filter: "url(#icon-home-filter-" + id + ")" },
            React.createElement("path", { d: "M9.51 1.433a.75.75 0 01.98 0l7 6.058a.75.75 0 01.26.567V17a.75.75 0 01-.75.75H3a.75.75 0 01-.75-.75V8.058a.75.75 0 01.26-.567l7-6.058zM3.75 8.4v7.85h12.5V8.4L10 2.992 3.75 8.4z" }),
            React.createElement("path", { d: "M13.515 8.454a.75.75 0 01.03 1.06l-3.772 4a.75.75 0 01-1.037.052l-1.728-1.5a.75.75 0 01.984-1.132l1.184 1.028 3.278-3.477a.75.75 0 011.06-.03z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "#icon-home-clip-path-" + id },
                React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })),
            React.createElement("filter", { id: "icon-home-filter-" + id, width: "31.5", height: "32.5", x: "-5.75", y: "-2.75", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
                React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                React.createElement("feOffset", { dy: "4" }),
                React.createElement("feGaussianBlur", { stdDeviation: "4" }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })))));
}
export default IconHomeChecked;
